import { FC } from 'react';
import { AuthCode } from 'components/AuthCode';

export const AuthCodePage: FC = () => {
	return <AuthCode />;
};
